import React from 'react';
import { ShoppingBag, ArrowRight, Check, Store } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const EcommercePage = () => {
  const { login } = useAuth();
  const features = ['Recuperação de carrinhos', 'Suporte ao cliente', 'Rastreamento de pedidos', 'Recomendações com IA'];
  const useCases = ['Lojas virtuais', 'Marketplaces', 'D2C', 'Dropshipping'];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-purple-100 text-purple-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <ShoppingBag className="h-4 w-4" />E-commerce
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                ChatAlfa para <span className="text-purple-600">E-commerce</span>
              </h1>
              <p className="text-xl text-gray-600 mb-8">Recupere carrinhos abandonados e aumente conversões com chatbots inteligentes.</p>
              <Button onClick={login} size="lg" className="bg-[#3b82f6] hover:bg-[#2563eb]">Começar gratuitamente</Button>
            </div>
            <div className="bg-purple-50 rounded-3xl p-8">
              <Store className="h-16 w-16 text-purple-600 mb-6" />
              <h3 className="font-bold text-xl mb-2">Lojas Online</h3>
              <p className="text-gray-600">+15% em conversão de vendas</p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Recursos para E-commerce</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((f) => (<div key={f} className="bg-white rounded-xl p-6 shadow-sm"><Check className="h-6 w-6 text-green-500 mb-3" /><p className="font-medium text-gray-900">{f}</p></div>))}
            </div>
          </div>
        </div>
        <div className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Tipos de Negócio</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {useCases.map((uc) => (<Card key={uc} className="hover:shadow-lg transition-shadow"><CardContent className="p-6"><p className="font-medium text-gray-900">{uc}</p></CardContent></Card>))}
            </div>
          </div>
        </div>
        <div className="py-16"><div className="max-w-4xl mx-auto px-4"><Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white"><CardContent className="py-12 text-center"><h2 className="text-2xl font-bold mb-4">Aumente suas vendas online</h2><Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">Começar agora <ArrowRight className="ml-2 h-4 w-4" /></Button></CardContent></Card></div></div>
      </main>
      <Footer />
    </div>
  );
};
export default EcommercePage;
